import { useState } from "react";
import { Reply, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, fmtDateTime, waLink } from "@/lib/api";
import { trackUrl } from "@/lib/route";
import { toast } from "sonner";

const notifyMsg = (r, store, slug) => `Olá, ${r.customer.split(" ")[0]}! A ${store} respondeu a sua avaliação do pedido #${r.number}. Veja aqui: ${trackUrl(slug, { id: r.order_id })}`;

export function ReplyBox({ r, canReply, store, slug, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(r.reply?.text || "");
  const [busy, setBusy] = useState(false);
  const save = async (value) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/ratings/${r.order_id}/reply`, { text: value });
      onSaved(r.order_id, data.reply); setEditing(false); setText(data.reply?.text || "");
      toast.success(data.reply ? "Resposta publicada na página do pedido" : "Resposta removida");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (editing) return (
    <div className="space-y-2 pt-1" data-testid={`reply-editor-${r.number}`}>
      <Textarea value={text} onChange={(e) => setText(e.target.value.slice(0, 500))} rows={2} placeholder="Escreva a resposta da loja (o cliente vê na página do pedido)" data-testid={`reply-input-${r.number}`} />
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" onClick={() => save(text)} disabled={busy || !text.trim()} data-testid={`reply-save-${r.number}`}>Publicar resposta</Button>
        <Button size="sm" variant="ghost" onClick={() => { setEditing(false); setText(r.reply?.text || ""); }}>Cancelar</Button>
        {r.reply && <Button size="sm" variant="ghost" className="text-red-500" onClick={() => save("")} disabled={busy} data-testid={`reply-delete-${r.number}`}>Remover resposta</Button>}
        <span className="ml-auto text-[11px] text-muted-foreground">{text.length}/500</span>
      </div>
    </div>
  );
  return (
    <div className="space-y-1">
      {r.reply && (
        <div className="rounded-lg border-l-4 border-primary bg-muted/40 px-3 py-2 text-sm" data-testid={`reply-text-${r.number}`}>
          <p className="text-[11px] font-semibold text-primary">Resposta da loja · {r.reply.by} · {fmtDateTime(r.reply.at)}</p>
          <p>{r.reply.text}</p>
        </div>
      )}
      <div className="flex flex-wrap items-center gap-3 text-xs">
        {canReply && <button type="button" onClick={() => setEditing(true)} className="flex items-center gap-1 font-medium text-primary" data-testid={`reply-btn-${r.number}`}><Reply className="h-3.5 w-3.5" />{r.reply ? "Editar resposta" : "Responder"}</button>}
        {r.reply && r.phone && <a href={waLink(r.phone, notifyMsg(r, store, slug))} target="_blank" rel="noreferrer" className="flex items-center gap-1 font-medium text-emerald-600" data-testid={`reply-notify-${r.number}`}><MessageCircle className="h-3.5 w-3.5" />Avisar cliente no WhatsApp</a>}
      </div>
    </div>
  );
}
